var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.875L11.25 13.5",
    stroke: "#F64E60",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.875L15.75 13.5",
    stroke: "#F64E60",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 7.875H23.625V7.875C22.5766 7.875 22.0524 7.875 21.639 8.04627C21.0876 8.27463 20.6496 8.71265 20.4213 9.26396C20.25 9.67745 20.25 10.2016 20.25 11.25V18C20.25 20.1213 20.25 21.182 19.591 21.841C18.932 22.5 17.8713 22.5 15.75 22.5H11.25C9.12868 22.5 8.06802 22.5 7.40901 21.841C6.75 21.182 6.75 20.1213 6.75 18V11.25C6.75 10.2016 6.75 9.67745 6.57873 9.26396C6.35037 8.71265 5.91235 8.27463 5.36104 8.04627C4.94755 7.875 4.42337 7.875 3.375 7.875V7.875Z",
    stroke: "#F64E60",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3267 3.79191C11.4549 3.67231 11.7373 3.56662 12.1303 3.49124C12.5232 3.41586 13.0047 3.375 13.5 3.375C13.9953 3.375 14.4768 3.41586 14.8697 3.49124C15.2627 3.56662 15.5451 3.67231 15.6733 3.79191",
    stroke: "#F64E60",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashLight);
export default __webpack_public_path__ + "static/media/Trash_light.ef12912688613d392b66b66d29228d3d.svg";
export { ForwardRef as ReactComponent };